export * from './endpoints.gen';
import { generatedAPI } from './endpoints.gen';

export const announcementBannerAPI = generatedAPI.enhanceEndpoints({});
